/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-magic-numbers */
import {
  Box3,
  BufferGeometry,
  Mesh,
  Object3D,
  Vector3,
  MeshBasicMaterial,
  MeshNormalMaterial,
  MeshPhongMaterial,
  DoubleSide,
  Vector2,
} from '@technology/web3d-plugin-threejs';
import { constructGeometry } from '../processing/qm-factory';
import { QmDecoder } from '../processing/qm-decoder';
import { QuantizedMeshSettings } from '../config/qm-settings';
import { QuantizedMeshOptions } from '../types/quantized-mesh-options';
import { MapProjection } from '../types/map-projection';
import { TileFetcher } from '../types/quantized-mesh-options';

export declare type TileMesh = Mesh<
  BufferGeometry,
  MeshBasicMaterial | MeshNormalMaterial | MeshPhongMaterial
>;

export class TileViewer {
  private mesh!: TileMesh;
  public readonly box: Box3;
  private readonly qmSettings: QuantizedMeshSettings;

  public isLoading(): boolean {
    return false;
  }

  constructor(
    private readonly root: Object3D,
    tileFetcher: TileFetcher,
    private readonly decoder: QmDecoder
  ) {
    this.box = new Box3(new Vector3(-150, -150, 0), new Vector3(150, 150, 150));

    // const boxContainerHelper = new Box3Helper(this.box, 0x00ffff);
    // const mapBoxContainerHelper = new Box3Helper(this.mapBox, 0xff0000)
    // this.root.add(boxContainerHelper);
    // this.root.add(mapBoxContainerHelper)

    const options: QuantizedMeshOptions = {
      modelId: 'qm-model',
      tileAvailableFn: () => true,
      tileFetcher,
      debug: true,
      meshSettings: {
        displayMode: 'terrain',
        baseHeight: null,
      },
      tileOptions: {
        rootCoordinate: new Vector2(0, 0),
        imageSize: 256,
        maxZoomLevel: 20,
        rootZoomLevel: 0,
      },
      constrainCamera: false,
      projection: {
        proj4def:
          '+proj=merc +a=6378137 +b=6378137 +lat_ts=0 +lon_0=0 +x_0=0 +y_0=0 +k=1 +units=m +nadgrids=@null +wktext +no_defs +type=crs',
        bounds: [
          // eslint-disable-next-line no-magic-numbers
          new Vector2(-20037508.342789244, -20037508.342789244),
          // eslint-disable-next-line no-magic-numbers
          new Vector2(20037508.342789244, 20037508.342789244),
        ],
      },
    };

    const sceneProjection: MapProjection = {
      proj4def:
        '+proj=tmerc +lat_0=-43.5905555555556 +lon_0=172.726944444444 +k=1 +x_0=400000 +y_0=800000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +type=crs',
      bounds: [
        new Vector2(-20037471.20513706, -20037471.20513706),
        new Vector2(20037471.20513706, 20037471.20513706),
      ],
    };
    this.qmSettings = new QuantizedMeshSettings(options, sceneProjection);
  }

  getMeshMaterial(params: any) {
    let MaterialConstructor;
    const materialParameters: any = {
      polygonOffset: true,
      polygonOffsetFactor: 1,
      polygonOffsetUnits: 1,
      flatShading: true,
    };

    switch (params.appearance) {
      case 'normal': {
        MaterialConstructor = MeshNormalMaterial;
        break;
      }
      case 'basic': {
        MaterialConstructor = MeshBasicMaterial;
        materialParameters.color = 0x0000ff;
        break;
      }
      case 'phong': {
        MaterialConstructor = MeshPhongMaterial;
        materialParameters.color = 0x0000ff;
        break;
      }
    }

    if (!MaterialConstructor) {
      throw new Error(`Unknown appearance type: ${params.appearance}`);
    }

    return new MaterialConstructor(materialParameters);
  }

  private tileToWebMercatorBbox(x: number, y: number, z: number) {
    // Number of tiles along one axis at the given zoom level
    const numTiles = Math.pow(2, z);
    const HALF_CIRCUMFERENCE_METERS = 20037508.342789244;
    // The width (and height) of a single tile in meters
    const tileWidth = (2 * HALF_CIRCUMFERENCE_METERS) / numTiles;

    // Calculate the bounds
    const minX = -HALF_CIRCUMFERENCE_METERS + x * tileWidth;
    const maxX = -HALF_CIRCUMFERENCE_METERS + (x + 1) * tileWidth;

    const maxY = HALF_CIRCUMFERENCE_METERS - y * tileWidth;
    const minY = HALF_CIRCUMFERENCE_METERS - (y + 1) * tileWidth;

    return { minX, minY, maxX, maxY };
  }

  async createMesh(tile: { x: number; y: number; z: number }): Promise<void> {
    const data = await this.decoder.fetchAndDecode(tile, new AbortController());

    console.log('Quantized mesh data fetched:', data);
    const containerSize = new Vector3();
    this.box.getSize(containerSize);

    const { x, y, z } = tile;

    const bbox = this.tileToWebMercatorBbox(x, y, z);
    const mapBox = new Box3();
    mapBox.min.set(bbox.minX, bbox.minY, 0);
    mapBox.max.set(bbox.maxX, bbox.maxY, containerSize.z);
    const { geometry } = constructGeometry(
      data,
      mapBox,
      this.qmSettings.mapToScene.bind(this.qmSettings),
      0,
      0
    );

    const material = this.getMeshMaterial({ appearance: 'normal' });
    material.side = DoubleSide;
    material.needsUpdate = true;
    this.mesh = new Mesh(geometry, material);
    material.wireframe = true;
    const localBox = new Box3();
    localBox.setFromObject(this.mesh);
    this.box.copy(localBox);

    this.root.add(this.mesh);
  }
}
